module.exports = __webpack_public_path__ + "img/star2.e9587a20.svg";